module.exports = __webpack_public_path__ + "assets/media/day18.b9c6854f.mp3";